// QSL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/QSL_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Countries, PlayingStatus, Clubs, BqRegoLink
let PlayerAccred
let step1, step2


// QSL Player Step Schema
const Load_QSL_Player_Steps = () => {
    return {
        Portal: '2024 QSL Player',
        MainColor: "#f5924c",
        Logo: require(`../../assets/QSLT.png`),
        Title: `<h2>2024 QSL1 Player Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    PlayingStatus: {
                        type: "select",
                        label: "Playing Status",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Playing Status is Required')],
                        items: PlayingStatus,
                        value: '',
                        onInput: async (ev, portal) => {
                            if (ev.data.PlayingStatus == "Australian Citizen") {
                                ev.schema.birthCountry.hidden = true
                                ev.schema.birthCountry.rules = []
                                ev.schema.BAApproval.hidden = true
                                ev.schema.BAApproval.rules = []
                                ev.schema.Proof.hidden = store.getters.passport
                                ev.schema.Proof.rules = (store.getters.passport) ? [] : [rules.requiredMsg('Passport / Citizenship is Required'), rules.fileSize()]
                                ev.schema.hasProof.hidden = !store.getters.passport
                            } else {
                                ev.schema.birthCountry.hidden = false
                                ev.schema.birthCountry.rules = [rules.requiredMsg('Country of Birth is Required')]
                                ev.schema.BAApproval.hidden = false
                                ev.schema.BAApproval.rules = [rules.requiredMsg('BA Approval Notice is Required'), rules.fileSize()]
                                ev.schema.Proof.hidden = true
                                ev.schema.Proof.rules = []
                                ev.schema.hasProof.hidden = true
                            }
                        },
                        OUG: { Contact_Details: { Type: 3366, Action: "Unique" } }
                    },
                    Proof: {
                        type: 'file',
                        label: 'Passport / Citizenship',
                        multiple: false,
                        outlined: true,
                        hidden: true,
                        dense: true,
                        accept: "image/*,application/pdf",
                        rules: [],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: 'Passport or proof of Citizenship',
                            }
                        },
                    },
                    hasProof: {
                        type: 'text',
                        dense: true,
                        disabled: true,
                        hidden: true,
                        class: 'mx-1 px-1',
                        Startslot: `<H4 style="text-align:center;color:red">We have already sighted your Passport or proof of Citizenship</H4>`
                    },
                    birthCountry: {
                        type: 'select',
                        label: 'Country of Birth?',
                        outlined: true,
                        hidden: true,
                        dense: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        items: Countries,
                        value: '',
                        OUG: { Contact_Details: { Type: 3394, Action: "Unique" } }
                    },
                    BAApproval: {
                        type: 'file',
                        label: 'Please upload proof notice you have received approval from Basketball Australia for this competition year',
                        multiple: false,
                        accept: "image/*,application/pdf",
                        outlined: true,
                        dense: true,
                        hidden: true,
                        col: 12,
                        rules: [],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: 1867,
                                Action: "SingleDesc",
                                Description: "BA Approval Notice",
                            }
                        },
                    },
                    CompSelect: {
                        "type": "select",
                        "label": "Competition Selection",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Competition Selection is Required')],
                        class: 'mx-1 px-1',
                        items: settings.CompType,
                        onInput: async (ev, portal) => {
                            Clubs = await settings.LookupTeams({
                                State_Champs: 3505,
                                Gender: functions.getCompGender(ev.data.CompSelect)
                            })
                            ev.schema.Club.items = Clubs
                        }
                    },
                    Club: {
                        "type": "select",
                        "label": "Which Club are you registering for?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Club is Required')],
                        class: 'mx-1 px-1',
                        items: Clubs,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: 1,
                        Accreditation: PlayerAccred,
                        AccredStart: '',
                        AccredEnd: '',
                        noDataText: 'Please Enter Competition Selection First',
                        AccredTeam: 3505,
                        onInput: async (ev, portal) => {
                            ev.schema.BQRego.hidden = false
                            BqRegoLink = `<a href="${settings.LoadBQRegoLink(portal.Model.Club.Association)}" target="_blank">Click Here</a>`
                            if (portal.Model.BQExpiryDate > settings.ConfEndDate) {
                                ev.schema.BQRego.Endslot = `<h3 style="text-align:center;color:green"> Your Basketball Connect BQ Registration is current and will expire on 
                                        ${functions.FormatDate(portal.Model.BQExpiryDate, 'DD/MM/YYYY')} which is after the end of the 2024 NBL1 Competition.</h3>`
                            } else {
                                ev.schema.BQRego.Endslot = `<h3 style="text-align:center;color:red"><p>Your Basketball Connect BQ Registration either could not be found 
                                        or is due to expire before the end of the 2024 NBL1 Competition</p>
                                        <p>This will have to be rectified before your registration will be approved
                                        </p>
                                        <p>Please use the link below to update your registration</p>
                                        <p>${BqRegoLink}</p></h3>`
                            }
                        },
                        OUG: { Contact_Roles: true, Type: "Teams" }
                    },
                    Position: {
                        type: "select",
                        label: "Playing Position",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Playing Position is required')],
                        class: 'mx-1 px-1',
                        items: settings.PlayerRoles,
                        value: '',
                        OUG: { Contact_Details: { Type: 346, Action: "Unique" } }
                    },
                    BQRego: {
                        type: 'text',
                        label: 'Basketball Connect BQ Registration Status',
                        disabled: true,
                        col: 12,
                        hidden: true,
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep

                    store.getters.birthCountry ? portal.Model.birthCountry = store.getters.birthCountry : null
                    store.getters.birthCountry ? Schema.birthCountry.value = store.getters.birthCountry : null
                    store.getters.PlayingStatus ? portal.Model.PlayingStatus = store.getters.PlayingStatus : null
                    store.getters.PlayingStatus ? Schema.PlayingStatus.value = store.getters.PlayingStatus : null

                    Schema.Proof.hidden = store.getters.passport
                    Schema.Proof.rules = (store.getters.passport) ? [] : [rules.requiredMsg('Passport / Citizenship is Required'), rules.fileSize()]
                    Schema.hasProof.hidden = !store.getters.passport
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Confirmation',
                valid: true,
                information: ``,
                Schema: {
                    Participate: {
                        addText: "",
                        type: 'checkbox',
                        label: `I have read and agree to the terms and conditions of participation 
                                        in QSL1 as laid out in QSL1 Rules.`,
                        color: "primary",
                        value: "Agree to all Terms and Conditions for QSL1",
                        rules: [rules.requiredMsg('Confirmation of acceptance of Terms and Conditions for QSL1 is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Participation</h3>`,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/55e04730-5930-4e15-8145-04e01ef5f6de.pdf" target="blank">
                                        QSL1 Rules</a>`,
                        OUG: { Answer: true }
                    },
                    cocConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Queensland Code of Conduct`,
                        color: "primary",
                        value: "Confirm I will adhere to BQ Code of Conduct",
                        rules: [rules.requiredMsg('Confirmation of Code of Conduct is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Code of Conduct</h3>`,
                        Endslot: `<a href="https://assets-global.website-files.com/645c37312e4131ceca6d3887/6461903dbf7e8d2d4187eea8_BQ-Codes-of-Behaviour.pdf" target="blank">
                                        Basketball Queensland Code of Conduct</a>`,
                        OUG: { Answer: true }
                    },
                    foreignPlayer: {
                        type: 'checkbox',
                        label: `I agree that if I do not currently have Australian Citizenship, I will gain Basketball Australia approval each competition year so I am eligible to play in any QSL1 match.`,
                        color: "primary",
                        value: "I Confirm I meet Foreign Player Conditions",
                        rules: [rules.requiredMsg('Confirmation of Foreign Player Requirement is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Foreign Player Requirements</h3>`,
                        Endslot: `<a href="https://www.australia.basketball/get-involved/pathways/immigration" target="blank">
                            Basketball Australia Immigration Policy (non current Australian Citizens)</a>`,
                        OUG: { Answer: true }
                    },
                    baIntegrityConfirm: {
                        addText: "",
                        type: 'checkbox',
                        label: `I agree to abide by Basketball Australia's National Integrity Framework`,
                        color: "primary",
                        value: "Agree to BA National Integrity Framework",
                        rules: [rules.requiredMsg('Confirmation of BA Integrity Requirements is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>BA National Integrity Framework</h3>`,
                        Endslot: `<a href="https://australia.basketball/integrity/" target="blank">
                                        Basketball Australia National Integrity Framework</a>`,
                        OUG: { Answer: true }
                    },
                    useImages: {
                        addText: "",
                        type: 'checkbox',
                        label: `I acknowledge that BQ, QSL and my Club may use images, video, or similar of me for the promotion of the League and the Club.`,
                        color: "primary",
                        value: "Acknowledge use of my Images and Video",
                        rules: [rules.requiredMsg('Use of Images confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Use of Images</h3>`,
                        OUG: { Answer: true }
                    },
                    Concussion: {
                        type: 'checkbox',
                        label: `I confirm that I will adhere to the Basketball Queensland Concussion Protocols`,
                        color: "primary",
                        value: "I Confirm I will adhere to BQ Concussion Protocols",
                        rules: [rules.requiredMsg('Confirmation of BQ Concussion Protocols is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Concussion Requirements</h3>`,
                        Endslot: `<a href="https://admin.ownurgoal.net.au/_lib/file/OUGImages/BA-Concussion-Guidelines-Harcourt-FINAL.pdf" target="blank">
                                            Basketball Queensland Concussion Protocols</a>`,
                        OUG: { Answer: true }
                    },
                    attendTribunal: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I undertake to attend meetings of the Basketball Queensland Tribunal whenever required to do so and consent to the subsequent reporting of the proceedings of such meetings and hearings.',
                        color: "primary",
                        value: "Agree to attend Tribunal or other meetings",
                        rules: [rules.requiredMsg('Agreement to Attend is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Tribunal</h3>`,
                        OUG: { Answer: true }
                    },
                    infoAccurate: {
                        addText: "",
                        type: 'checkbox',
                        label: 'I confirm that I have provided infomation honestly and that it is both true and accurate.',
                        color: "primary",
                        value: "Confirm information all honest and correct",
                        rules: [rules.requiredMsg('Accurate Information confirmation is Required')],
                        class: 'mx-1 px-1',
                        col: 12,
                        Startslot: `<h3>Information Provided</h3>`,
                        OUG: { Answer: true }
                    },
                },
            },
            // Step 5
            {
                stepno: 5,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 QSL1 season.<br></br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the 
                            league and you and your Association Delegate will receive an email notification 
                            once your registration has been reviewed and approved by the league.<br></br>
                            If your registration has not been approved the league will contact your 
                            Association Delegate to inform them of any further requirements to meet 
                            league eligibility approval for the season.<br></br>

                            <b>Please note that if your registration has been submitted during the 
                            season after 4pm on the Friday prior to a weekends round your 
                            registration will NOT be reviewed and/or approved until the following 
                            round as you have missed that weekends round deadline to submit your 
                            registration.</b>
                            <hr><br></br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Countries = await functions.GetCountries();
        PlayingStatus = await functions.GetCodeBy({ Type: "NBL1 Playing Status" });
        PlayerAccred = settings.PlayerAccred
        return Load_QSL_Player_Steps()
    },



}

